var $ = require('jquery');
//直接引用，避免循环依赖
var BootstrapDialog = require('../bootstrap/bootstrap-dialog');
var m_loading = require('../components/loading');

/**
 * @deprecated 包装 jquery.ajax，返回为一个 Promise，（删除success , error , 和 complete 回调方法）
 * @param url
 * @param options 增加 trfOpt 属性
 *   {
 *     _method : 'GET' //值为 RESTful 动词
 *   }
 * @returns {Promise<void>|Promise.<*>|Promise<R>}
 */
module.exports = function (url, options) {
    // If url is an object, simulate pre-1.5 signature
    if (typeof url === "object") {
        options = url;
        url = undefined;
    }

    var defaults = {
        trfOpt: {
            useCommon : false,
            dataBack: compatibleData,//页数接口返回数据回调
            stringify: false,//序列化成json传给服务器
            dataError: false,//提示错误信息
            serverError: true,//服务器错误信息
            loading:null,//当为字符串时显示loading提示，不需要文字时传 ''
            loadingOpt:{
                icon:'fa-cog fa-spin',
                className: 'ajax-loading'
            }//参看trf.loading
        }
    };
    if(options.trfOpt && options.trfOpt.useCommon){
        var ajaxOpt = {
            type: 'POST',
            dataType: 'json',
            trfOpt: {
                stringify: true,
                loading: ''
            }
        };
        options = $.extend(true, defaults,ajaxOpt, options || {});
    }
    else {
        // Force options to be an object
        options = $.extend(true, defaults, options || {});
    }

    if(url){
        options.url = url;
    }
    var trfOpt = options.trfOpt || {};
    var _method = trfOpt._method;

    if ($.type(options.data) === 'object') {
        if (_method && /^(?:GET|POST|PUT|DELETE)$/.test(_method)) {
            options.data._method = _method;
        }
        if (trfOpt.stringify) {
            options.data = {
                json: JSON.stringify(options.data)
            }
        }
    }

    // 兼容处理，不推荐后台返回这种格式数据
    function compatibleData(data) {
        if(data!=null && data.data == null && data.error != null && data.error.code == 0){
            data.data = data.error.msg || true;
            data.error = null;
        }
    }
    function dealDataBack(dataBack, data) {
        var temp;
        if ($.type(dataBack) === 'function') {
            temp = dataBack.call(null, data);
        }
        return temp != null ? temp : data;
    }
    function dealDataError(data) {
        if (data!=null && data.data == null && data.error != null) {
            if (data.error.code === 'A01' || (Array.isArray(data.error.codes) && data.error.codes.indexOf('A01') != -1)) {
                BootstrapDialog.alert(data.error.msg);
            }
        }
    }
    function dealServerError(err) {
        if (err.status == 200) {
            BootstrapDialog.alert('服务器返回数据格式错误!');
        } else {
            BootstrapDialog.alert('服务器出错，返回状态码：' + err.status + '，返回状态信息：' + err.statusText);
        }
    }
    function dealStart() {
        if($.type(trfOpt.loading) === 'string'){
            dealStart.oldLoading = m_loading(trfOpt.loading,trfOpt.loadingOpt);
        }
    }

    function dealEnd() {
        if(dealStart.oldLoading){
            dealStart.oldLoading.hide();
        }
    }

    dealStart();//请求前处理

    return new Promise(function (resolve, reject) {
        delete  options.complete;
        delete  options.success;
        delete  options.error;

        $.ajax(options).then(function (data) {
            data = dealDataBack(trfOpt.dataBack, data);
            trfOpt.dataError && dealDataError(data);
            dealEnd();
            resolve(data);
        },function (err) {
            trfOpt.serverError && dealServerError(err);
            dealEnd();
            reject(err);
        });
    });

};



//////////////////
// WEBPACK FOOTER
// ./src/core/ajax.js
// module id = 17
// module chunks = 0